import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';
import useProfile, {
  generateGetProfileData,
} from '../../../../hooks/useProfile';
import { IUserProfileData } from '../../../../interfaces/profile.interface';

interface IBusinessProfileModeContext {
  data: IUserProfileData | undefined;
  setData: Dispatch<SetStateAction<IUserProfileData | undefined>>;
  initData: IUserProfileData | undefined;
}

export const BusinessProfileModeContext =
  createContext<IBusinessProfileModeContext>({
    data: undefined,
    setData: () => undefined,
    initData: undefined,
  });

export const BusinessProfileProvider = ({
  initData,
  children,
}: {
  initData: IUserProfileData;
  children: ReactNode;
}) => {
  const [data, setData] = useState<IUserProfileData | undefined>(undefined);

  useProfile(
    generateGetProfileData({
      userId: `${initData?.profiles?.ownerId}` || '',
    }),
    {
      initialData: initData,
      enabled: !!initData?.profiles?.ownerId,
      onSuccess: (data) => {
        setData(data);
      },
      onError: (_error) => {
        setData(undefined);
      },
    }
  );

  return (
    <BusinessProfileModeContext.Provider value={{ data, setData, initData }}>
      {children}
    </BusinessProfileModeContext.Provider>
  );
};
